export enum InsuranceType {
  NONE = '',
  COUNTED_MULTIYEAR = 'COUNTED_MULTIYEAR',
  FINANCED_MULTIYEAR = 'FINANCED_MULTIYEAR',
  FINANCED_ANNUAL = 'FINANCED_ANNUAL',
  COUNTED_ANNUAL = 'COUNTED_ANNUAL',
  CLIENT = 'CLIENT',
  NOT_INSURANCE = 'NOT_INSURANCE',
  COUNTED_LIFE = 'COUNTED_LIFE',
  FINANCED_LIFE = 'FINANCED_LIFE'
}

export const filtersInsuranceType = [
  {formControlName: 'annualPayment', value: InsuranceType.COUNTED_ANNUAL, description: 'Anual contado'},
  {formControlName: 'annualFinanced', value: InsuranceType.FINANCED_ANNUAL, description: 'Anual financiado'},
  {
    formControlName: 'multiAnnualPayment',
    value: InsuranceType.COUNTED_MULTIYEAR,
    description: 'Multianual contado'
  },
  {
    formControlName: 'multiAnnualFinanced',
    value: InsuranceType.FINANCED_MULTIYEAR,
    description: 'Multianual financiado'
  },
  {
    formControlName: 'clientAccount',
    value: InsuranceType.CLIENT,
    description: 'Por cuenta del cliente'
  },
  {formControlName: 'noInsurance', value: InsuranceType.NOT_INSURANCE, description: 'Sin seguro'},
]

export const filterInsuranceLife =  [
  {formControlName: 'lifePayment', value: InsuranceType.COUNTED_LIFE, description: 'Vida contado'},
  {formControlName: 'lifeFinanced', value: InsuranceType.FINANCED_LIFE, description: 'Vida financiado'},
]

export const typesInsurance = {
  PRODUCT_INSURANCE: 'PRODUCT_INSURANCE',
  LIFE_INSURANCE: 'LIFE_INSURANCE'

}
export const optionsInsuranceType = [
  // {
  //   filterType: {
  //     name: 'Seguro del producto',
  //     type: typesInsurance.PRODUCT_INSURANCE,
  //     filter: filtersInsuranceType
  //   }
  // },
  {
    filterType: {
      name: 'Seguro de vida',
      type: typesInsurance.LIFE_INSURANCE,
      filter: filterInsuranceLife
    }
  }
];


